
import CarbonBarChart from '../components/CarbonBarChart'
import CarbonMap from '../components/CarbonMap'

export default {
    components: {CarbonBarChart, CarbonMap},
    data() {
        return {
            
        }
    },
}


// WEBPACK FOOTER //
// ./src/carbon/js/carbon_home.js